<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Settings</div>
            </base-header>
        </v-row>
        
        <v-row no-gutters>

            <v-col cols="12" lg="12" sm="12">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-card>
                            <v-toolbar flat dark>
                                <v-toolbar-title>SETTINGS</v-toolbar-title>
                            </v-toolbar>
                            <v-tabs vertical>
                                <v-tab>
                                    <v-icon left>
                                        settings
                                    </v-icon>
                                    Settings
                                </v-tab><v-tab>
                                    <v-icon left>
                                      apps

                                    </v-icon>
                                   Config
                                </v-tab>


                                <v-tab-item>
                                    <v-card flat>
                                        <card-api></card-api>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <card-config></card-config>
                                    </v-card>
                                </v-tab-item>

                            </v-tabs>
                        </v-card>
                    </div>
                </base-card>
            </v-col>

        </v-row>
        
          <card-slide-group></card-slide-group>

      
    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import CardApi from '../../components/Cards/CardApi.vue'
    import CardSlideGroup from '../../components/Cards/CardSlideGroup'
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardExchange from '../../components/Cards/CardExchange'
            import CardConfig from '../../components/Cards/CardConfig'
    export default {
        components: {
            BaseCard,
            CardApi,
            CardSlideGroup,
            BaseHeader,
            CardExchange,CardConfig

        },
    }
</script>